import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
import TreeNodeViewModel from "./../../../factories/tree-node";
import BaoMenu from "./../../../services/bao-menu";
import BaoDialog from "./../../../factories/bao-dialog";
import "./../../../bindings/bao-tree";
import "./../../../bindings/sorting";
import "./../../../bindings/foreach-selection";
import "./../../../bindings/bao-pager";
import "./../../../bindings/bao-toolbar2";

function ChecklistStartModuleViewModel(parent) {
    var self = this;
    self.SelectedNode = ko.observable(null);
    self.ResetInProgress = ko.observable(false);
    self.Initialized = ko.observable();
    self.TotalRows = ko.observable(0);
    self.Nodes = ko.observableArray([]);
    self.Columns = ko.observableArray([]);
    self.ChecklistCollection = ko.observableArray([]);
    self.Sorting = ko.observableArray([]);
    self.PageIndex = ko.observable(0);
    self.PageSize = ko.observable(20);
    self.SelectedRow = ko.observable();
    self.IncompleteMode = ko.observable(false);
    self.ShowTrashcan = false;
    var _deleteEvaluationMessage = Bao.Session.GetMessage("msgDeleteEvaluation");

    self.Refresh = function () {
        return self.LoadChecklists(true);
    };

    parent.Refresh = function () {
        var def = $.Deferred();
        self.Refresh().then(function () {
            def.resolve();
        });
        return def.promise();
    };

    self.Sorting.subscribe(function () {
        if (self.Initialized() == true && self.ResetInProgress() == false) {
            self.LoadChecklists(true);
        }
    });

    self.PageIndex.subscribe(function () {
        if (self.Initialized() == true && self.ResetInProgress() == false) {
            self.LoadChecklists(true);
        }
    });

    self.PageSize.subscribe(function () {
        if (self.Initialized() == true && self.ResetInProgress() == false) {
            self.LoadChecklists(true);
        }
    });

    self.SelectedNode.subscribe(function () {
        self.IncompleteMode(!(self.SelectedNode() != null && self.SelectedNode().FolderStructureId() != null));
        if (self.SelectedNode() != null) {
            self.RefreshGrid();
        }
    });

    self.SelectedRow.subscribe(function () {
        BaoMenu.permissionEnable({
            ActionKey: "ChecklistEvaluationDeleteIncomplete",
            Enabled: self.IncompleteMode() && self.SelectedRow() != null,
            Context: parent.TabPage.Context()
        });
    });

    var tabMenuClicked = function (permission) {
        if (parent.TabPage.IsActiveTab()) {
            switch (permission.ActionKey()) {
                case "ChecklistEvaluationRefresh":
                    self.LoadOrgUnits();
                    break;
                case "ChecklistEvaluationDeleteIncomplete":
                    self.DeleteIncompleteChecklist();
                    break;
            }
        }
    };

    BaoMenu.registerEvent(tabMenuClicked);
    self.LoadTree = function () {
        parent.TabPage.IsLoading(true);
        self.SelectedNode(null);
        self.ResetValues();
        return Bao.post("Module/LoadTree", function (result) {
            var arrayNodes = [];
            ko.utils.arrayForEach(result, function (item) {
                arrayNodes[arrayNodes.length] = new TreeNodeViewModel(item, self);
            });
            self.Nodes(arrayNodes);
            parent.TabPage.IsLoading(false);
            self.SelectedRow.valueHasMutated();
        });
    };

    self.LoadOrgUnits = function () {
        parent.TabPage.IsLoading(true);
        self.ResetValues();
        return Bao.post("Module/LoadOrgUnits", function (result) {
            var arrayNodes = [];
            ko.utils.arrayForEach(result, function (item) {
                arrayNodes[arrayNodes.length] = new TreeNodeViewModel(item, self);
            });
            self.Nodes(arrayNodes);
            parent.TabPage.IsLoading(false);
            self.SelectedRow.valueHasMutated();
        });
    };

    self.LoadColumns = function () {
        return Bao.post("Module/LoadColumns", JSON.stringify({
            key: self.SelectedNode()?.Key(),
            folderStructureId: self.SelectedNode()?.FolderStructureId()
        }));
    };

    self.LoadChecklists = function (independentRefresh) {
        parent.TabPage.IsLoading(true);
        return Bao.post("Module/LoadChecklists", JSON.stringify({
            key: self.SelectedNode()?.Key(),
            folderStructureId: self.SelectedNode()?.FolderStructureId(),
            sorting: self.Sorting(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize()
        }), function (result) {
            if (independentRefresh) {
                parent.TabPage.IsLoading(false);
                self.ChecklistCollection(result.Models);
            }
        });

    };

    self.ResetValues = function () {
        self.ResetInProgress(true);
        self.Columns([]);
        self.TotalRows(0);
        self.PageIndex(0);
        self.ChecklistCollection([]);
        self.Sorting([]);
        self.SelectedRow(null);
        self.ResetInProgress(false);
    };

    self.RefreshGrid = function () {
        parent.TabPage.IsLoading(true);
        self.ResetValues();
        return $.when(self.LoadColumns(), self.LoadChecklists()).then(function (columns, checklists) {
            self.Columns(columns[0]);
            self.ChecklistCollection(checklists[0].Models);
            self.TotalRows(checklists[0].TotalRows);
            parent.TabPage.IsLoading(false);
        });
    };

    self.DeleteIncompleteChecklist = function (item) {
        if (item != null) {
            var yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, _deleteEvaluationMessage, "yesno");
            yesNoDialog.DialogResult.subscribe(function (result) {
                if (result === true) {
                    parent.TabPage.IsLoading(true);
                    return Bao.post("Module/DeleteIncompleteEvaluation", JSON.stringify({
                        evaluationId: item.EvaluationId
                    }), function (deleteResult) {
                        self.RefreshGrid();
                    });
                }
            });
        }
    };

    self.init = function () {
        Bao.bindEvent("checkware:refresh_folderstructurechecklist", function () {
            self.LoadOrgUnits();
        });
        return self.LoadOrgUnits();
    };

    self.loaded = function () {
        self.Initialized(true);
    };

}
export default ChecklistStartModuleViewModel;